export default {
  users: [],
  companyList: [],
  count: 0,
  offset: 0,
  limit: 50,
  isLoading: false,
  isSubmitting: false,
  isRouteWatched: false,
  validationErrors: null,
};
